import firebase from 'firebase/app';

export type BoardPost = {
  isAdmin: boolean;
  userID: string;
  name: string;
  title: string;
  text: string;
  category: string;
  postTime: firebase.firestore.Timestamp;
  isPublic: boolean;
};

export type BoardCategory = 'fromAdmin' | 'others' | 'advertising';

export const boardCategory: { key: BoardCategory; name: string }[] = [
  { key: 'fromAdmin', name: '運営だより' },
  { key: 'others', name: '一般' },
  { key: 'advertising', name: '広告・宣伝' },
];

export const boardPostWithDefault = (data: Partial<BoardPost>): BoardPost => {
  return {
    isAdmin: data.isAdmin ?? false,
    userID: data.userID ?? '',
    name: data.name ?? '',
    title: data.title ?? '',
    text: data.text ?? '',
    category: data.category ?? '',
    postTime:
      data.postTime ?? firebase.firestore.Timestamp.fromDate(new Date()),
    isPublic: data.isPublic ?? true,
  };
};

export const boardCategoryWithDefault = (text: string): BoardCategory => {
  switch (text) {
    case 'fromAdmin':
    case 'others':
    case 'advertising':
      return text;
    default:
      return 'others';
  }
};
